<template>
  <div>
    <h3 class="title">日粮</h3>
    <blend-material :rowId="rowId" :url="rationUrl" :factoryId="factoryId" :columns="rationColumns" :valKeys="rationKeys"/>
    <h3 class="title mt20">补充料</h3>
    <blend-material :rowId="rowId" :url="supplementUrl" :factoryId="factoryId" :columns="supplementColumns" :valKeys="supplementKeys" :details="details"/>
  </div>
</template>
<script>
import BlendMaterial from "./BlendMaterial";
import {rationColumns,supplementColumns} from './blendConfig'
let rationKeys = []
let supplementKeys = []
rationColumns.forEach(el => {
  if(el.scopedSlots) rationKeys.push(el.dataIndex)
})
supplementColumns.forEach(el => {
  if(el.scopedSlots) supplementKeys.push(el.dataIndex)
})
export default {
  props: ['rowId','factoryId','details'],
  components: {BlendMaterial},
  data(){
    return {
      supplementColumns,rationColumns,supplementKeys,rationKeys,
      rationUrl: '/nhf-app/archivedFormula/formulaMixRawList',
      supplementUrl: '/nhf-app/archivedFormula/formulaRawList',
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  padding: 0 15px;
  font-size: 16px;
  font-weight: bold;
}
.mt20{
  margin-top: 20px;
}
</style>
